import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import ReturnNote from '../../../../../components/return-notes/edit-return-note';
import { FormattedMessagePropType } from '../../../../../prop-types/intl';
import { useCreateReturnContext } from '../../../context/create-return-provider';

import style from './notes.module.less';

const noteFieldId = 'return-note';

const Editable = ({ labelMessage }) => {
  const { note, updateNote, returnFulfillmentPlanId } = useCreateReturnContext();

  return (
    <>
      <Text className={style['note-label']} htmlFor={noteFieldId} textType={TextType.Label} value={labelMessage} />
      <ReturnNote
        className={style['note-input']}
        fulfillmentPlanId={returnFulfillmentPlanId}
        hideAddNoteButton
        id={noteFieldId}
        noteBody={note}
        updateNote={updateNote}
      />
    </>
  );
};

export default Editable;

Editable.propTypes = {
  labelMessage: FormattedMessagePropType.isRequired,
};
